import React from 'react'

export default function ExcelToPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)">
          <path
            fill="currentColor"
            d="m25.91 5.89-.3-.3L21.02 1l-.2-.2c-.5-.5-1.2-.8-1.9-.8H3.05C1.55 0 .25 1.3.25 2.8v26.85c0 1.6 1.3 2.8 2.8 2.8h13.18c-.2-.3-.3-.7-.4-1H3.25c-1.1 0-2-.9-2-2V2.9c0-1 .8-1.8 1.8-1.8h15.97c.3 0 .7.1.9.4l.5.5 4.19 4.19.7.7c.2.2.3.4.3.7v12.28c.3 0 .6.1.9.1V7.49c0-.6-.2-1.2-.6-1.6Z"
          />
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M26.57 7.81v12.11c-.61-.1-1.21-.2-1.82-.2-4.85-.3-8.99 3.33-9.4 8.07v1.01c0 1.11.2 2.32.71 3.33H2.52c-1.11 0-2.02-.91-2.02-2.02V2.26C.5 1.15 1.41.24 2.52.24H19.5c.51 0 1.01.2 1.41.61l5.05 5.25c.4.4.61 1.11.61 1.72v-.01Z"
            opacity=".1"
          />
          <path
            fill="currentColor"
            d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9c-4.1 0-7.5 3.3-7.5 7.5s3.3 7.5 7.5 7.5 7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
          />
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
          />
          <path
            fill="currentColor"
            d="M7.41 12a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088H4.468a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.028-.155.08-.21A.26.26 0 0 1 4.468 12H7.41Zm-2.67 1.551h2.397v-.954H4.741v.954Z"
          />
          <path
            fill="currentColor"
            d="M10.351 12a.26.26 0 0 1 .193.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.193.088H7.41a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21A.26.26 0 0 1 7.41 12h2.941Zm-2.669 1.551h2.397v-.954H7.682v.954Z"
          />
          <path
            fill="currentColor"
            d="M13.293 12a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088H10.35a.26.26 0 0 1-.192-.088.314.314 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M16.235 12a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M19.176 12a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.941a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M22.118 12a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.028-.155.08-.21a.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Zm-12.038 0a.26.26 0 0 1 .192.087c.051.056.08.132.08.211V15.4c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088H4.468a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.028-.155.08-.21a.261.261 0 0 1 .192-.088H7.41Zm-2.67 1.551h2.397v-.954H4.741v.954Z"
          />
          <path
            fill="currentColor"
            d="M10.351 13.551a.26.26 0 0 1 .193.087c.051.056.08.132.08.211V15.4c0 .08-.029.155-.08.211a.261.261 0 0 1-.193.088H7.41a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397v-.954H7.682v.954Z"
          />
          <path
            fill="currentColor"
            d="M13.293 13.551c.072 0 .141.031.193.087a.32.32 0 0 1 .08.211V15.4c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088H10.35a.261.261 0 0 1-.192-.088.314.314 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M16.235 13.551a.26.26 0 0 1 .192.087c.051.056.08.132.08.211V15.4c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M19.176 13.551c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211V15.4c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.941a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M22.118 13.551a.26.26 0 0 1 .192.087c.051.056.08.132.08.211V15.4c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.028-.155.08-.21a.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Zm-12.038 0a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088H4.468a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21V15.4c0-.079.028-.155.08-.21a.261.261 0 0 1 .192-.088H7.41Zm-2.67 1.551h2.397V15.7H4.741v.954Z"
          />
          <path
            fill="currentColor"
            d="M10.351 15.102a.26.26 0 0 1 .193.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.193.088H7.41a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.4c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397V15.7H7.682v.954Z"
          />
          <path
            fill="currentColor"
            d="M13.293 15.102c.072 0 .141.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088H10.35a.261.261 0 0 1-.192-.088.314.314 0 0 1-.08-.21V15.4a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398V15.7h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M16.235 15.102a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.4c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397V15.7h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M19.176 15.102c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.941a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.4a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398V15.7h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M22.118 15.102a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21V15.4c0-.079.028-.155.08-.21a.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397V15.7h-2.397v.954Zm-12.038 0a.26.26 0 0 1 .192.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088H4.468a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21V16.95c0-.079.028-.155.08-.21a.26.26 0 0 1 .192-.088H7.41Zm-2.67 1.551h2.397v-.954H4.741v.954Z"
          />
          <path
            fill="currentColor"
            d="M10.351 16.653a.26.26 0 0 1 .193.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.193.088H7.41a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.95c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397v-.954H7.682v.954Z"
          />
          <path
            fill="currentColor"
            d="M13.293 16.653a.26.26 0 0 1 .193.088c.05.055.08.131.08.21v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088H10.35a.26.26 0 0 1-.192-.088.314.314 0 0 1-.08-.21V16.95a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M16.235 16.653a.26.26 0 0 1 .192.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.95c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M19.176 16.653a.26.26 0 0 1 .193.088c.05.055.08.131.08.21v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.941a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.95a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="currentColor"
            d="M22.118 16.653a.26.26 0 0 1 .192.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21V16.95c0-.079.028-.155.08-.21a.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Zm-14.98-5.906h-.436v6.324h.436v-6.324Z"
          />
          <path
            fill="currentColor"
            d="M4.468 12a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211v6.324c0 .079-.03.155-.08.21a.26.26 0 0 1-.193.088h-.436a.26.26 0 0 1-.192-.087.313.313 0 0 1-.08-.211v-6.324a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h.436Z"
          />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M9.904 3.25c.387 0 .646.263.646.657v6.047c-.13.263-.388.526-.646.526H3.966c-.388 0-.646-.263-.646-.657V3.907c0-.394.258-.657.646-.657h5.938Zm-3.98 3.798-1.506-2.63h1.506l.965 1.839.99-1.838h1.495L7.852 7.048l1.564 2.63h-1.49L6.89 7.858 5.87 9.677H4.363l1.561-2.63Z"
            clip-rule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
